//Mixin para uso de constantes de Monedas
const currencys = {
    PESO_CURRENCY: 1,
    USD_CURRENCY: 2,
    UF_CURRENCY: 3
  };
  
  export { currencys };
  